import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Textarea, Group, Text, Box, Divider, Button } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { arrCekDoubleBarangFisik } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";
// import StepQCReminderMaintenanceModal from "./StepQCReminderMaintenanceModal";

const StepQC = ({
    stateData,
    stateShowNextComponent = false,
    fnCloseDrawer,
    fnSuccessTakesThisProject
}) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        successSubmitSelesai: 'stepQC-1',
        errorSubmitSelesai: 'stepQC-2',

        successSubmitBelum: 'stepQC-3',
        errorSubmitBelum: 'stepQC-4'
    })

    const [data, setData] = React.useState({
        selesaiConfirmationModal: false,
        selesaiSubmitLoading: false,

        belumConfirmationModal: false,
        belumSubmitLoading: false,
        belumInfo: '',
        belumInfoError: '',

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const selesaiQC = () => {
        setData(d => ({ ...d, selesaiSubmitLoading: true }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process_pengerjaan', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('project_process_selesai', utils.projectProcess.selesai.value);
        formDT.append('project_pengerjaan_qc_approved', JSON.stringify(utils.pengerjaanProgress.qc_approved));
        formDT.append('arr_cek_double_barang_fisik', JSON.stringify(arrCekDoubleBarangFisik()));

        axios({
            method: 'post',
            url: BE_API_TWO + '/selesai_qc',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                selesaiSubmitLoading: false,
                selesaiConfirmationModal: false
            }));

            if (response.data.flag_status === 'isset') {
                fnCloseDrawer();

                notifications.show({
                    id: notificationId.current.successSubmitSelesai,
                    title: utils.notification.success.caption,
                    message: 'Berhasil Submit Data',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })

                fnSuccessTakesThisProject();
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitSelesai,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'double-barang-fisik') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Barang ini sedang dalam proses service dan belum dilakukan pengambilan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'can-not-be-edit') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Terdapat progres yang belum diposting!',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'not-complete-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: response.data.message,
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                selesaiSubmitLoading: false,
                selesaiConfirmationModal: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitSelesai,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const qcBelumSesuai = () => {
        setData(d => ({ ...d, belumInfoError: '' }));

        if (validator.isEmpty(data.belumInfo, { ignore_whitespace: true })) {
            setData(d => ({ ...d, belumInfoError: 'Isi keterangan terlebih dahulu.' }));
        } else {
            setData(d => ({ ...d, belumSubmitLoading: true }))

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('project_id', stateData.projectId);
            formDT.append('project_process_pengerjaan', stateData.projectProcess);
            formDT.append('project_is_cancel', stateData.projectIsCancel);

            formDT.append('project_process_pengerjaan_value', utils.projectProcess.pengerjaan.value);
            // formDT.append('project_pengerjaan_progress', JSON.stringify(utils.pengerjaanProgress.pengerjaan));
            formDT.append('project_pengerjaan_qc_reject', JSON.stringify(utils.pengerjaanProgress.qc_rejected));

            formDT.append('keterangan_belum_sesuai_qc', data.belumInfo);

            axios({
                method: 'post',
                url: BE_API_TWO + '/tolak_qc',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, belumSubmitLoading: false, belumConfirmationModal: false }));

                if (response.data.flag_status === 'isset') {
                    fnCloseDrawer();

                    notifications.show({
                        id: notificationId.current.successSubmitBelum,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Submit Data',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })

                    fnSuccessTakesThisProject();
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitBelum,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'can-not-be-edit') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Terdapat progres yang belum diposting!',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'not-complete-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: response.data.message,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    belumSubmitLoading: false,
                    belumConfirmationModal: false
                }))

                notifications.show({
                    id: notificationId.current.errorSubmitBelum,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    return (
        <React.Fragment>
            {stateShowNextComponent &&
                <Box mt='3rem' mb='4rem'>
                    <PaperWrapper>
                        <Text size='sm' mb='xs' color="dimmed">
                            Barang sudah selesai di Q.C ?
                        </Text>

                        <Divider />

                        <Text size='sm' my='xs' color="dimmed">
                            Pastikan barang sudah di Q.C dengan benar.
                        </Text>

                        <Text size='sm' my='xs' color="dimmed">
                            Jika barang masih belum sesuai dan masih harus diperbaiki, pilih "Belum Sesuai" untuk kembali ke step pengerjaan.
                        </Text>

                        <Text size='sm' mt='xs' mb='lg' color="dimmed">
                            Jika barang sudah benar dan sesuai, pilih "Selesai".
                        </Text>

                        <Group noWrap>
                            <Button
                                variant="light" color="red"
                                fullWidth
                                onClick={() => {
                                    setData(d => ({ ...d, belumConfirmationModal: true }));
                                }}
                            >
                                Belum Sesuai
                            </Button>

                            <Button
                                fullWidth
                                onClick={() => {
                                    setData(d => ({ ...d, selesaiConfirmationModal: true }));
                                }}
                            >
                                Selesai
                            </Button>
                        </Group>
                    </PaperWrapper>
                </Box>
            }

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.selesaiConfirmationModal}
                fnHide={() => setData(d => ({ ...d, selesaiConfirmationModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Selesai'
                stateButtonActionPx='xs'
                stateButtonActionColor=""
                stateButtonActionLoading={data.selesaiSubmitLoading}
                fnButtonAction={selesaiQC}
            >
                <Text size='sm' color="dimmed">
                    Project ini telah selesai dikerjakan. Barang siap diambil oleh Customer.
                    <br /><br />
                    Lanjutkan ?
                </Text>
            </ModalTakeAction>

            {/* <StepQCReminderMaintenanceModal
                stateShow={data.selesaiConfirmationModal}
                fnShow={() => setData(d => ({ ...d, selesaiConfirmationModal: false }))}

                stateData={{
                    projectId: stateData.projectId,
                    projectProcess: stateData.projectProcess,
                    projectIsCancel: stateData.projectIsCancel,
                    projectProcessSelesai: utils.projectProcess.selesai.value,
                    projectPengerjaanQCApproved: JSON.stringify(utils.pengerjaanProgress.qc_approved),
                    arrayCekDoubleBarangFisik: JSON.stringify(arrCekDoubleBarangFisik())
                }}

                fnSuccess={() => {
                    fnCloseDrawer();

                    notifications.show({
                        id: notificationId.current.successSubmitSelesai,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Submit Data',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })

                    fnSuccessTakesThisProject();
                }}
            /> */}

            <ModalTakeAction
                stateShow={data.belumConfirmationModal}
                fnHide={() => setData(d => ({ ...d, belumConfirmationModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Kembali Ke Pengerjaan'
                stateButtonActionPx='xs'
                stateButtonActionColor=""
                stateButtonActionLoading={data.belumSubmitLoading}
                fnButtonAction={qcBelumSesuai}
            >
                <Text size='sm' color="dimmed">
                    Project ini akan kembali ke tahap pengerjaan.
                </Text>

                <Textarea
                    value={data.belumInfo}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) =>
                        setData(d => ({
                            ...d,
                            belumInfo: e.target.value
                        }))
                    }

                    mt='md'
                    label='Keterangan'
                    placeholder='Keterangan / Catatan Tolak Q.C'
                    error={data.belumInfoError}
                    description=''
                    withAsterisk={false}
                />
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default StepQC;